import {connect} from "react-redux";
import Waiting from "./Waiting";
import {getOrder} from "../GlobalReduxState/action";

const mapStateToProps = (state:any)=> ({
    order: state.globalReducer.order,
    cssStyles: state.globalReducer.styles
});

//CHECK this
const mapDispatchToProps = (dispatch:any) =>({
    callGetOrder: (domainId: any) => dispatch(getOrder(domainId)),
});

export default connect(mapStateToProps,mapDispatchToProps)(Waiting);
